<template>
  <div>
  <section class="magazine-gallery">
    <div class="magazine-gallery__wrapper">
      <div class="magazine-gallery__flex-tall" data-aos="fade-in" data-aos-offset="200">
        <CardMagazineGallery image="christmas-gallery-1.jpg"/>
      </div>
      <div class="magazine-gallery__flex-wide" data-aos="fade-in" data-aos-offset="200">
        <CardMagazineGallery image="christmas-gallery-3.jpg"/>
      </div>
    </div>
    <div class="magazine-gallery__wrapper">
      <div class="magazine-gallery__flex-wide" data-aos="fade-in" data-aos-offset="200">
        <CardMagazineGallery image="christmas-gallery-2.jpg"/>
      </div>
      <div class="magazine-gallery__flex-tall" data-aos="fade-in" data-aos-offset="200">
        <CardMagazineGallery image="christmas-gallery-4.jpg"/>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import CardMagazineGallery from '@/components/CardMagazineGallery.vue'
export default {
  name: 'MagazineGallery',
  components: {
    CardMagazineGallery
  }
}
</script>

<style lang="postcss">
.magazine-gallery {
  @apply -mx-4 flex flex-wrap;

}
.magazine-gallery__wrapper {
  @apply flex flex-col w-full justify-start;
}
.magazine-gallery__flex-tall,
.magazine-gallery__flex-wide {
  @apply flex;
  flex: 1 1 auto;
}
.magazine-gallery__flex-tall .magazine-gallery-block__image {
  aspect-ratio: 16 / 8;
}
.magazine-gallery__flex-wide .magazine-gallery-block__image {
  aspect-ratio: 4 / 3;
}
@screen sm {
  .magazine-gallery {
    /* @apply flex-no-wrap; */
  }
  .magazine-gallery__wrapper {
    @apply flex-1 mb-0;
  }
  /* .magazine-gallery__flex-tall,
  .magazine-gallery__flex-wide {
    @apply min-h-0;
  } */
  /* .magazine-gallery__flex-tall {
    flex: 2 1 400px;
  }
  .magazine-gallery__flex-wide {
    flex: 1 1 200px;
  } */
}
  @screen md {
    .magazine-gallery__wrapper {
      flex:1 1 100%;
  }
  }
@screen lg {
  .magazine-gallery__wrapper {
    @apply flex-1 ;
  }
  .magazine-gallery {
    @apply flex-no-wrap;
  }
}
</style>
